import { tokenManager } from './tokenManager';
import api from './axios';

/**
 * Calls the /auth/refresh endpoint with the refresh token and returns new tokens.
 * Throws if refresh fails or no refresh token is available.
 */
export async function refreshAccessToken() {
  const refreshToken = tokenManager.get('refreshToken');
  if (!refreshToken) {
    throw new Error('No refresh token available');
  }
  const res = await api.post(`${import.meta.env.VITE_API_BASE_URL}/auth/refresh`, {
    refreshToken,
  });
  const { accessToken, refreshToken: newRefreshToken } = res.data;
  // Update tokens
  tokenManager.set('accessToken', accessToken, 15 * 60 * 1000);
  tokenManager.set('refreshToken', newRefreshToken, 7 * 24 * 60 * 60 * 1000);
  return { accessToken, refreshToken: newRefreshToken };
}
